import { CompanyTitledPage } from "../../TitledPage";

import { SAMPLE_BASIC_MARKET_CLOSING_CONDITION_LIST } from "../../../common/SampleData";
import { dayWeekToString, getYearMonthDateDisplay } from "../../../utils/utils";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useOutletContext } from "react-router-dom";
import { Checkbox, Dialog, Grid, OutlinedInput, Radio, TextareaAutosize, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ScheduleConditionApplyDateRangeForm, ScheduleConditionDateForm, ScheduleConditionDayWeekForm, ScheduleConditionHolidayForm, ScheduleConditionMemoForm } from "../../../components/ScheduleConditionSetting";
import { yellow } from "@mui/material/colors";

import { SYSTEM_PATH_COMPANY } from "../../../App";

const getBasicClosedConditions = () => {
  return [...SAMPLE_BASIC_MARKET_CLOSING_CONDITION_LIST];
}

function BasicClosedConditionRow ({basicClosedCondition, onClickChangeSetting, onClickDeleteSetting})  {

  const {month: month, date: date, week: week, day_code: dayCode, holiday_code: holidayCode, memo: memo, apply_start_date: applyStartDate, apply_end_date:applyEndDate} = basicClosedCondition;
  
  let holidayStr = "-";

  if (holidayCode === 1) {
    holidayStr = "祝日";
  } else if (holidayCode === 2) {
    holidayStr = "祝日以外";
  }
  
  return (
    <TableRow>
      <TableCell>
        {month ? month.toString() + "月" : "-"}
      </TableCell>
      <TableCell>
        {date ? date.toString() + "日" : "-"}
      </TableCell>
      <TableCell>
        {week ? "第" + week.toString() : ""}
        {dayCode ? dayWeekToString(dayCode) + "曜日" : "-"}
      </TableCell>
      <TableCell>
        {holidayStr}
      </TableCell>
      <TableCell>
        {applyStartDate ? getYearMonthDateDisplay(new Date(applyStartDate)) : "-" }
      </TableCell>
      <TableCell>
        {applyEndDate ? getYearMonthDateDisplay(new Date(applyEndDate)) : "-" }
      </TableCell>
      <TableCell>
        {memo}                      
      </TableCell>
      <TableCell width="8%" sx={{padding: 1}}>
        <Button variant="contained" onClick={onClickChangeSetting}>設定変更</Button>
      </TableCell>
      <TableCell width="8%" sx={{padding: 1}}>
        <Button variant="contained" color="error" onClick={onClickDeleteSetting}>設定削除</Button>
      </TableCell>
    </TableRow>
  )
} 

function BasicClosedListTable ({getOnClickChangeSettingFunc, getOnClickDeleteSettingFunc}) {

  const basicClosedConditions = getBasicClosedConditions();

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              月
            </TableCell>
            <TableCell>
              日
            </TableCell>
            <TableCell>
              曜日
            </TableCell>
            <TableCell>
              祝日
            </TableCell>
            <TableCell>
              適用開始
            </TableCell>
            <TableCell>
              適用終了
            </TableCell>
            <TableCell>
              メモ
            </TableCell>
            <TableCell>
              設定変更
            </TableCell>
            <TableCell>
              設定削除
            </TableCell>
          </TableRow>
          {
            basicClosedConditions.map((bcc_data, bcc_i) => (
              <BasicClosedConditionRow
                key={"bcc_" + bcc_i}
                basicClosedCondition={bcc_data}
                onClickChangeSetting={getOnClickChangeSettingFunc(bcc_data.closing_condition_id)}
                onClickDeleteSetting={getOnClickDeleteSettingFunc(bcc_data.closing_condition_id)}
              />
            ))
          }        
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function BasicClosedConditionSettingDialog({open, onClose, closingConditionId, updateBasicClosedCondition}) {

  const [basicClosedConditionInput, setBasicClosedConditionInput] = useState({
    closing_condition_id: null,
    month: "",
    date: "",
    every_month: false,
    week: "",
    certain_week_apply: false,
    day_code: "",
    holiday_apply: true,
    not_holiday_apply: true,
    memo: "",
    apply_start_date: "",
    apply_end_date: ""
  });

  useEffect(() => {
    initBasicClosedCondition(closingConditionId);
  }, [open, closingConditionId])


  const initBasicClosedCondition = (closingConditionId) => {

    const basicClosedCondition = SAMPLE_BASIC_MARKET_CLOSING_CONDITION_LIST.find((bcc_data) => bcc_data.closing_condition_id === closingConditionId);

    if (basicClosedCondition) {
      setBasicClosedConditionInput({
        closing_condition_id: null,
        month:  basicClosedCondition.month ? basicClosedCondition.month.toString() : "",
        date: basicClosedCondition.date ? basicClosedCondition.date.toString() : "",
        every_month: Boolean(basicClosedCondition.date) && !Boolean(basicClosedCondition.month),
        week: basicClosedCondition.week ? basicClosedCondition.week.toString() : "",
        certain_week_apply: Boolean(basicClosedCondition.week),
        day_code: basicClosedCondition.day_code ? basicClosedCondition.day_code.toString() : "",
        holiday_apply: !basicClosedCondition.holiday_code || basicClosedCondition.holiday_code === 0 || basicClosedCondition.holiday_code === 1,
        not_holiday_apply: !basicClosedCondition.holiday_code || basicClosedCondition.holiday_code === 0 || basicClosedCondition.holiday_code === 2,
        memo: basicClosedCondition.memo,
        apply_start_date: basicClosedCondition.apply_start_date ? basicClosedCondition.apply_start_date : "",
        apply_end_date: basicClosedCondition.apply_end_date ? basicClosedCondition.apply_start_date : ""
      });
      return;
    }

    setBasicClosedConditionInput({
      closing_condition_id: null,
      month: "",
      date: "",
      every_month: false,
      week: "",
      certain_week_apply: false,
      day_code: "",
      holiday_apply: true,
      not_holiday_apply: true,
      memo: "",
      apply_start_date: "",
      apply_end_date: ""
    });
  }

  const dialogUpdateString = closingConditionId ? "変更" : "追加";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box padding={2} minWidth={600}>
        <Typography fontSize={20} fontWeight={700} marginBottom={2}>基本休場日{dialogUpdateString}</Typography>
        
        <Grid container spacing={2} alignItems="center" marginBottom={2}>
          <Grid item xs="auto">
            設定範囲
          </Grid>
          <Grid item xs="auto">
            <ScheduleConditionApplyDateRangeForm
              conditionInput={basicClosedConditionInput}
              setConditionInput={setBasicClosedConditionInput}
            />
          </Grid>
        </Grid>
        
        <Box>
          設定条件
          <Box marginLeft={2} marginTop={1}>
            <Grid container spacing={2} alignItems="center" marginBottom={2}>
              <Grid item xs={1}>
                日付 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionDateForm
                  conditionInput={basicClosedConditionInput}
                  setConditionInput={setBasicClosedConditionInput}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}  alignItems="baseline" marginBottom={2}>
              <Grid item xs={1}>
                曜日 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionDayWeekForm
                  conditionInput={basicClosedConditionInput}
                  setConditionInput={setBasicClosedConditionInput}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" marginBottom={2}>
              <Grid item xs={1}>
                祝日 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionHolidayForm
                  conditionInput={basicClosedConditionInput}
                  setConditionInput={setBasicClosedConditionInput}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="top" marginBottom={2}>
              <Grid item xs={1}>
                メモ : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionMemoForm
                  conditionInput={basicClosedConditionInput}
                  setConditionInput={setBasicClosedConditionInput}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
          
        <Grid container columnSpacing={1} textAlign="right">
          <Grid item xs>
            <Button variant="contained" onClick={onClose}>設定</Button> 
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClose}>キャンセル</Button> 
          </Grid>           
        </Grid>
        
      </Box>
    </Dialog>
  )
}

function BasicClosedConditionDeleteDialog({open, onClose, closingConditionId, deleteBasicClosedCondition}) {

  if (!open) {
    return;
  }

  let basicClosedCondition = SAMPLE_BASIC_MARKET_CLOSING_CONDITION_LIST.find((bcc_data) => bcc_data.closing_condition_id === closingConditionId);

  if (open && !basicClosedCondition) {
    alert("エラーが発生しました。")
    onClose(null);
    return;
  }

  const {month: month, date: date, week: week, day_code: dayCode, holiday_code: holidayCode, memo: memo, apply_start_date: applyStartDate, apply_end_date:applyEndDate} = basicClosedCondition;
  
  let holidayStr = "-";

  if (holidayCode === 1) {
    holidayStr = "祝日";
  } else if (holidayCode === 2) {
    holidayStr = "祝日以外";
  }
  
  return(
    <Dialog open={open} onClose={onClose}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>基本休場日設定削除</Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の基本休場日の設定を削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>月:&nbsp;{month ? month.toString() + "月" : "-"}</Typography>
            <Typography fontSize={20}>日:&nbsp;{date ? date.toString() + "日" : "-"}</Typography>
            <Typography fontSize={20}>曜日:&nbsp;{week ? "第" + week.toString() : ""}{dayCode ? dayWeekToString(dayCode) + "曜日" : "-"}</Typography>
            <Typography fontSize={20}>祝日:&nbsp;{holidayStr}</Typography>
            <Typography fontSize={20}>適用開始日:&nbsp;{applyStartDate ? getYearMonthDateDisplay(new Date(applyStartDate)) : "-"}</Typography>
            <Typography fontSize={20}>適用終了日:&nbsp;{applyEndDate ? getYearMonthDateDisplay(new Date(applyEndDate)) : "-"}</Typography>
            <Typography fontSize={20}>メモ:&nbsp;{memo}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign='center'>
            <Button
              variant="contained"
              color='error'
              onClick={onClose}
            >
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign='center'>
            <Button variant="outlined" onClick={onClose}>戻る</Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}


// 基本休場日一覧ページ
export default function BasicClosedListPage() {

  const navigate = useNavigate();

  const [conditionSettingDialogMode, setConditionSettingDialogMode] = useState(0);
  const [selectedClosingConditionId, setSelectedClosingConditionId] = useState(null);

  const onClickReturnCalendar = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/market_calendar")
  }

  const onClickAddSetting = (event) => {
    setSelectedClosingConditionId(null);
    setConditionSettingDialogMode(1);
  }

  const onCloseSettingDialog = (event) => {
    setConditionSettingDialogMode(0);
  }

  const getOnClickChangeSettingFunc = (closingConditionId) => ((event) => {
    setSelectedClosingConditionId(closingConditionId);
    setConditionSettingDialogMode(1);
  })

  const getOnClickDeleteSettingFunc = (closingConditionId) => ((event) => {
    setSelectedClosingConditionId(closingConditionId);
    setConditionSettingDialogMode(2);
  })

  return (
    <CompanyTitledPage title="基本休場日一覧">
      <Grid container spacing={1}>
        <Grid item xs />
        <Grid item xs="auto">
          <Button variant="contained" onClick={onClickAddSetting}>設定追加</Button>
        </Grid>
        <Grid item xs="auto">
          <Button variant="contained" onClick={onClickReturnCalendar}>カレンダーに戻る</Button>
        </Grid>
      </Grid>
      <BasicClosedListTable
        getOnClickChangeSettingFunc={getOnClickChangeSettingFunc}
        getOnClickDeleteSettingFunc={getOnClickDeleteSettingFunc}
      />
      <BasicClosedConditionSettingDialog
        open={conditionSettingDialogMode === 1}
        onClose={onCloseSettingDialog}
        closingConditionId={selectedClosingConditionId}
      />
      <BasicClosedConditionDeleteDialog
        open={conditionSettingDialogMode === 2}
        onClose={onCloseSettingDialog}
        closingConditionId={selectedClosingConditionId}
      />
    </CompanyTitledPage>
  );
}
